import { Routes } from '@angular/router';
import { PricingHistoryComponent } from './pricing-history/pricing-history.component';
import { RecommendedPricesComponent } from './recommended-prices/recommended-prices.component';
import { LoginComponent } from '../shared/components/login/login.component';
import { MsalGuard } from '@azure/msal-angular';
import { LayoutComponent } from 'src/app/shared/components/ui/layout/layout.component';
import { KeyMetricsComponent } from './key-metrics/key-metrics.component';
import { Settings } from './settings/settings.component';
import { AuthGuard } from 'src/app/core/auth/authGuard';
import { AuditLogComponent } from './settings/audit-log/audit-log.component';

export const strategicPricingRoutes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'pricing-history',
        component: PricingHistoryComponent,
        canActivate: [MsalGuard],
        data: {
          reuseComponent: true
        }
      },
      {
        path: 'key-metrics',
        component: KeyMetricsComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'recommended-prices',
        component: RecommendedPricesComponent,
        canActivate: [MsalGuard],
        data: {
          reuseComponent: true
        }
      },
      {
        path: 'settings',
        component: Settings,
        canActivate: [MsalGuard, AuthGuard],
        data: {
          reuseComponent: true
        }
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'audit-log',
        component: AuditLogComponent,
        canActivate: [MsalGuard],
      },
      //TODO: Check this, weird behav
      { path: '', redirectTo: 'pricing-history', pathMatch: 'full' },
      { path: '**', redirectTo: 'pricing-history', pathMatch: 'full', data: { loginStatus : false}}
    ],
  },
];
